<script setup>
import { Icon } from '@iconify/vue2'
import { ref, useAttrs } from 'vue'
const { horizontal, recuo } = useAttrs()
const toggle = ref(false)
const colapsable = ref()

defineExpose(colapsable)
</script>

<template>
	<section
		ref="colapsable"
		class="container__colapsable__main"
		:class="[
			{
				horizontal: horizontal != undefined,
				vertical: horizontal == undefined,
				closed: toggle,
			},
		]"
	>
		<div
			class="container__colapsable__content"
			:style="{ width: 100 - (recuo || 0) + '%' }"
			:class="[
				{
					closed: toggle,
					horizontal: horizontal != undefined,
					vertical: horizontal == undefined,
				},
			]"
		>
			<slot v-if="!toggle" />
		</div>
		<div
			class="container__close"
			:class="{
				closed: toggle,
				horizontal: horizontal != undefined,
				vertical: horizontal == undefined,
			}"
			@click="toggle = !toggle"
		>
			{{ horizontal != undefined ? 'Tabela de atributos' : '' }}
			<Icon
				icon="material-symbols:arrow-forward-ios-rounded"
				:class="[
					'colapse__icon',
					{
						closed: toggle,
						horizontal: horizontal != undefined,
						vertical: horizontal == undefined,
					},
				]"
			/>
		</div>
	</section>
</template>

<style scoped>
.container__colapsable__main {
	@apply flex absolute;
}

.container__colapsable__main.horizontal {
	@apply flex-col-reverse;
}

.container__colapsable__content {
	@apply bg-white;
	transition-property: all;
	transition-duration: 300ms;
	transition-timing-function: ease-in;
	box-shadow: 2px 2px 4px 0px #1e1e1e40;
}

.container__colapsable__content.vertical {
	@apply min-w-[5vw] border-t border-b border-r border-gray-medium max-w-[100vh_-_50px] overflow-auto rounded-r;
}

.container__colapsable__content.horizontal {
	@apply min-h-[33vh] w-full border-r border-l border-t border-gray-medium;
}

.container__colapsable__content.closed.horizontal {
	@apply max-h-0 min-h-0;
}

.container__colapsable__content.closed.vertical {
	@apply max-w-0 min-w-0 w-0 border-none;
}

.container__close {
	@apply w-fit h-fit bg-white p-2 flex items-center gap-2 cursor-pointer;
}

.container__close.vertical {
	@apply mt-16 flex items-center gap-[9px] rounded-br-[4px] rounded-tr-[4px] ml-[-1px] !border-t !border-b !border-r border-black-neutral;
}

.container__close.horizontal {
	@apply mr-[40px] rounded-tl-[4px] rounded-tr-[4px] font-bold uppercase text-gray-dark text-xs z-[1] -mb-[2px] border-t border-r border-l border-black-neutral;
}

.container__colapsable__main.vertical {
	@apply bottom-0 h-[95%];
}

.container__colapsable__main.vertical.closed {
	@apply !min-w-0;
}

.container__colapsable__main.horizontal {
	@apply bottom-0 w-full items-end;
}

.colapse__icon {
	@apply text-gray-dark;
}

.colapse__icon.horizontal {
	@apply rotate-90;
}

.colapse__icon.closed.horizontal {
	@apply -rotate-90;
}

.colapse__icon.vertical {
	@apply rotate-180;
}

.colapse__icon.closed.vertical {
	@apply rotate-0;
}
</style>
